import { Button, TextToggler } from 'plume-ui';
import React, { memo, useState } from 'react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import FormattedMessage from '../../../../../utils/components/FormattedMessage';
import { AdjustableComponent } from '../../../../../utils/hooks/useClasses';

type ActionCellProps = {
  id: string;
  enabled?: boolean;
  setEnabled?: (id: string, enabled: boolean) => void;
  edit?: (id: string) => void;
  del?: (id: string) => void;
  editAllowed?: boolean;
  disableDelete?: boolean;
};

type ActionCellStyles = {};

const ActionCell: AdjustableComponent<ActionCellProps, ActionCellStyles> = ({
  id,
  setEnabled,
  enabled,
  edit,
  del,
  editAllowed,
  disableDelete,
}) => {
  const [toggleSelected, setToggleSelected] = useState<boolean>(
    enabled || false,
  );
  const [firstLoad, setFirstLoad] = useState(true);

  useEffect(() => {
    if (firstLoad) {
      setFirstLoad(false);
      return;
    }
    if (setEnabled !== undefined) {
      setEnabled(id, toggleSelected);
    }
  }, [toggleSelected]);

  const { t } = useTranslation();
  return (
    <div className="Configuration__collapseCard__webhook__table__rendered-cell">
      {edit !== undefined && (
        <Button
          styleVariant="tertiary"
          disabled={!editAllowed}
          onClick={() => {
            edit(id);
          }}
        >
          <FormattedMessage id="configuration.actions.edit" />
        </Button>
      )}
      {del !== undefined && (
        <Button
          styleVariant="tertiary"
          disabled={!editAllowed || disableDelete}
          onClick={() => {
            del(id);
          }}
        >
          <FormattedMessage id="configuration.actions.delete" />
        </Button>
      )}
      {enabled !== undefined && (
        <TextToggler
          title={t(
            `configuration.webhooks.${toggleSelected ? 'enabled' : 'disabled'}`,
          )}
          disabled={!editAllowed}
          selected={toggleSelected}
          onToggle={() => {
            setToggleSelected(!toggleSelected);
          }}
        />
      )}
    </div>
  );
};

export default memo(ActionCell);
